import _ from 'lodash'

const multiple_options = ['form-option', 'form-checkbox', 'form-yes-no', 'form-select', 'form-select-multinumeric', 'form-multinumeric']

const inArray = function (array, item) {
  let found = false
  array.forEach((_item) => {
    if (item === _item) {
      found = true
    }
  })
  return found
}

class Item {
  constructor (_item) {
    if (_item !== undefined) {
      if (_item.id !== null && _item.type === 'form-range') {
        if (typeof _item.options === 'string' && JSON.parse(_item.options) instanceof Array) {
          _item.options = '{"min": 0, "max": 99}'
        }
      }

      this.id = _item.id ? _item.id : null
      this.name = _item.name ? _item.name : ''
      this.type = _item.type ? _item.type : 'form-option'
      this.placeholder = _item.placeholder ? _item.placeholder : null
      this.description = _item.description ? _item.description : null
      this.answer = _item.answer ? _item.answer : null
      this.answer_extra_properties = _item.answer_extra_properties ? _item.answer_extra_properties : []
      this.value = _item.value != null ? _item.value : 1
      this.required = _item.required ? _item.required : false
      this.required_if = _item.required_if ? _item.required_if : null
      this.only_yes_no = _item.only_yes_no ? _item.only_yes_no : false
      this.inventory_columns = _item.inventory_columns ? JSON.parse(_item.inventory_columns) : null
      this.options = _item.options ? (typeof _item.options === 'string' ? JSON.parse(_item.options) : _item.options) : []
      this.order = _item.order ? _item.order : null
      this.min = _item.min ? _item.min : 1
      this.max = _item.max ? _item.max : 100
      this.option_values = _item.option_values ? _item.option_values : null
      this.comment_addon = _item.comment_addon != null ? _item.comment_addon : 0
      this.picture_addon = _item.picture_addon != null ? _item.picture_addon : 0
      this.second_picture_addon = _item.second_picture_addon != null ? _item.second_picture_addon : 0
      this.third_picture_addon = _item.third_picture_addon != null ? _item.third_picture_addon : 0
      this.fourth_picture_addon = _item.fourth_picture_addon != null ? _item.fourth_picture_addon : 0
      this.comment_addon_answer = null
      this.picture_addon_answer = null
      this.second_picture_addon_answer = null
      this.third_picture_addon_answer = null
      this.fourth_picture_addon_answer = null
      this.addons = _item.addons ? _item.addons : []
      this.barcode_scanner = _item.barcode_scanner ? _item.barcode_scanner : false
      this.priority = _item.priority ? _item.priority : null
      this.responsability = _item.responsability ? _item.responsability : null
      this.na_item = _item.na_item ? _item.na_item : false
      this.add_more_options = _item.add_more_options ? _item.add_more_options : false
      this.extra_properties = _item.extra_properties ? _item.extra_properties : []
      this.logic_properties = _item.logic_properties ? _item.logic_properties : []
      this.extra_properties_required_answer = _item.extra_properties_required_answer || null
      this.cloned_item = _item.cloned_item || {}
      this.rules = !_item.rules || _item.rules.length ? {} : _item.rules
      this.hyperlink = _item.hyperlink ? _item.hyperlink : null
      this.hyperlink_text = _item.hyperlink_text ? _item.hyperlink_text : null
      this.leadership = _item.leadership ? _item.leadership : null
      this.leadership_check = _item.leadership != null ? 1 : 0
      this.ai_reference_image = _item.ai_reference_image ? _item.ai_reference_image : null
      this.group_form_organization_id = _item.group_form_organization_id ? _item.group_form_organization_id : null
      this.attrs = {
        comment_addon: false,
        picture_addon: false,
        second_picture_addon: false,
        third_picture_addon: false,
        fourth_picture_addon: false
      }

      if (this.comment_addon_answer) {
        this.attrs.comment_addon = true
      }

      if (this.picture_addon_answer) {
        this.attrs.picture_addon = true
      }

      if (this.second_picture_addon_answer) {
        this.attrs.second_picture_addon = true
      }

      if (this.third_picture_addon_answer) {
        this.attrs.third_picture_addon = true
      }

      if (this.fourth_picture_addon_answer) {
        this.attrs.fourth_picture_addon = true
      }

      if (!_item.id && _item.type === 'form-yes-no') {
        this.options = [
          {
            option: 'yes',
            value: 1
          },
          {
            option: 'no',
            value: 0
          },
          {
            option: 'na',
            value: 0
          }
        ]
      }

      if ((!_item.id && _item.type === 'form-location') || (!_item.id && _item.type === 'form-select-multinumeric')) {
        this.options = []
        this.required = true
      }

      if (!_item.id && !_item.options && _item.type === 'form-option') {
        this.options = [{
          option: 'na',
          value: 0
        }]
      }

      if (!_item.id && _item.type === 'form-range') {
        this.options = {
          min: 0,
          max: 100
        }
      }
    } else {
      this.id = null
      this.name = ''
      this.type = 'form-option'
      this.placeholder = null
      this.description = null
      this.answer = null
      this.value = 1
      this.required = false
      this.required_if = null
      this.inventory_columns = []
      this.only_yes_no = false
      this.options = [
        {
          option: 'yes',
          value: 1
        },
        {
          option: 'no',
          value: 0
        },
        {
          option: 'na',
          value: 0
        }
      ]
      this.max = 100
      this.min = 1
      this.order = null
      this.picture_addon = 0
      this.comment_addon = 0
      this.second_picture_addon = 0
      this.third_picture_addon = 0
      this.fourth_picture_addon = 0
      this.comment_addon_answer = null
      this.picture_addon_answer = null
      this.barcode_scanner = false
      this.second_picture_addon_answer = null
      this.third_picture_addon_answer = null
      this.fourth_picture_addon_answer = null
      this.na_item = false
      this.add_more_options = false
      this.extra_properties = []
      this.logic_properties = []
      this.responsability = null
      this.answer_extra_properties = []
      this.extra_properties_required_answer = null
      this.cloned_item = {}
      this.rules = {}
      this.hyperlink = null
      this.hyperlink_text = null
      this.ai_reference_image = null
      this.group_form_organization_id = null
    }
  }

  get visible_comment_addon () {
    if (this.comment_addon === 0 || !this.answer) {
      return false
    } else if (this.comment_addon === 1) {
      return false
    } else if (this.comment_addon === 2 && this.real_value > 0) {
      return true
    } else if (this.comment_addon === 3 && this.real_value === 0 && this.answer !== 'na') {
      return true
    }
    return false
  }

  get visible_picture_addon () {
    if (this.picture_addon === 0 || !this.answer) {
      return false
    } else if (this.picture_addon === 1) {
      return true
    } else if (this.picture_addon === 2 && this.real_value > 0) {
      return true
    } else if (this.picture_addon === 3 && this.real_value === 0 && this.answer !== 'na') {
      return true
    }
    return false
  }

  get max_value () {
    if (this.answer === 'na' || this.arrayNAAnswer(this.answer)) {
      return 0
    }

    if (this.type === 'label') {
      return 0
    }

    if (this.type === 'form-fill-inventory') {
      return parseInt(this.value)
    }

    if (this.type === 'form-location') {
      return 0
    }

    if (this.type === 'form-select-multinumeric') {
      return 0
    }

    if (this.type === 'form-multinumeric') {
      return 0
    }

    if (this.type === 'form-input-number') {
      if (this.answer === 0) {
        return 0
      }
    }

    if (this.options.length > 0 && this.type !== 'form-catalog' && this.type !== 'form-inventory') {
      let max_value = 0
      if (this.type === 'form-checkbox') {
        this.options.forEach((option) => {
          max_value += parseInt(option.value)
        })
      } else {
        this.options.forEach((option) => {
          option.value = parseInt(option.value)
          if (max_value < option.value) {
            max_value = option.value
          }
        })
      }
      return max_value
    }

    return parseInt(this.value)
  }

  get real_value () {
    if (this.answer === 'na' || this.answer === 'NA') {
      return 0
    }

    if (this.type === 'form-fill-inventory') {
      return this.answer.indexOf(0) > -1 ? 0 : 1
    }

    let options = _.cloneDeep(this.options)
    // Check if the type is multioption, if an item does not have multiple options
    // it should not have values in array options we must ensure to set it to "[]" otherwise it will throw incorrect values
    if (!(inArray(multiple_options, this.type))) {
      options = []
    }

    if (options.length === 0) {
      if (this.answer) {
        return this.value
      }
      return 0
    }
    // si es opcion múltiple
    if (options.length > 0) {
      let total = 0
      // si es de tipo checkbox
      if (this.answer instanceof Array) {
        this.answer.forEach((ans) => {
          options.forEach((option) => {
            if (option.option === ans) {
              total += parseInt(option.value)
            }
          })
        })
      } else { // si es de radio button o select
        options.forEach((option) => {
          if (option.option === this.answer) {
            total += parseInt(option.value)
          }
        })
      }

      return total
    }

    return this.value
  }

  // set options (options) {
  //   this.options = options
  // }

  // get options () {
  //   return this.options
  // }

  // answer === ['na']
  arrayNAAnswer (answer) {
    return answer && Object.getPrototypeOf(answer)
      ? Object.getPrototypeOf(answer).constructor === Array && answer[0] && answer[0] === 'NA'
      : false
  }

  static getTypeDefaults (type) {
    const shared = {
      value: 1,
      min: 1,
      max: 100,
      option_values: null,
      inventory_columns: null,
      only_yes_no: false,
      barcode_scanner: false,
      add_more_options: false,
      priority: null
    }

    switch (type) {
      case 'form-table':
        return {
          ...shared,
          options: {
            columns: [],
            max_rows: 1,
            get_numeric_totals: true,
            scored_table: false,
            numeric_precision: 2,
            validate_table: false
          }
        }
      case 'form-checkitem':
        return {
          ...shared,
          options: { trueLabel: 'Hecho', falseLabel: 'Sin hacer' }
        }
      case 'form-reading':
        return {
          ...shared,
          options: { unit: 'm3', allow_decimals: false, show_difference: true, allow_negative: false }
        }
      case 'form-catalog':
        return { ...shared, options: null }
      case 'form-range':
        return { ...shared, options: { min: 0, max: 100 } }
      case 'form-yes-no':
        return {
          ...shared,
          options: [
            { option: 'yes', value: 1 },
            { option: 'no', value: 0 },
            { option: 'na', value: 0 }
          ]
        }
      case 'form-option':
        return { ...shared, options: [{ option: 'na', value: 0 }] }
      default:
        return { ...shared, options: [] }
    }
  }
}

export default Item
